import { cn } from '@/helpers/utils/functionality-utils';
import type { Nullable } from 'primereact/ts-helpers';

export const Flag = ({
  code,
  containerClassName,
  imgClassName,
  width = 30,
}: {
  code: Nullable<string>;
  containerClassName?: string;
  imgClassName?: string;
  width?: number;
}) => {
  if (!code) return null;
  return (
    <div
      className={cn(
        'size-fit shrink-0 overflow-hidden rounded-sm border',
        containerClassName,
      )}
    >
      <img
        alt="flag"
        src={`/flags/flag_placeholder.png`}
        className={cn(
          `flag h-5 object-contain flag-${code.toLowerCase()}`,
          imgClassName,
        )}
        width={width}
      />
    </div>
  );
};
